<template>
  <a-table
    :rowKey="rowKey"
    :childrenColumnName="childrenColumnName"
    :columns="columns"
    :data-source="dataSource"
    :pagination="pagination || false"
    :customRow="isDrag && customRow"
    :scopedSlots="$slots"
  >
    <template
      v-for="item in columns"
      :key="item.slots && item.slots.customRender"
      v-slot:[item.slots&&item.slots.customRender]="{ text, record, index }"
    >
      <slot
        :name="item.slots ? item.slots.customRender : ''"
        v-bind="{ text, record, index }"
      ></slot>
    </template>
  </a-table>
</template>
<script>
import { toRefs, reactive } from 'vue'
export default {
  name: 'DragTable',
  props: {
    isDrag: Boolean,
    dataSource: Array
  },
  setup(props, { attrs, emit }) {
    const state = reactive({
      ...attrs,
      ...props,
      sourceObj: null,
      targetObj: null,
      exchangeIndex: -1,
      dragStartEvent: null,
      prevTarget: null,
      level: 0,
      childrenColumnName: ''
    })

    const customRow = (record, index) => {
      return {
        props: {
          draggable: true
        },
        style: {
          cursor: 'pointer'
        },
        // 鼠标移入
        onMouseenter: event => {
          // 兼容IE
          let ev = event || window.event
          ev.target.draggable = true
        },
        // 开始拖拽
        onDragstart: event => {
          // 兼容IE
          let ev = event || window.event
          // 阻止冒泡
          ev.stopPropagation()
          // 得到源目标数据
          state.sourceObj = record
          state.exchangeIndex = index
        },
        // 拖动元素经过的元素
        onDragover: event => {
          // 兼容 IE
          let ev = event || window.event
          // 阻止默认行为
          ev.preventDefault()
          if (state.prevTarget) {
            state.prevTarget.classList.remove('drop-target')
          }
          state.prevTarget = ev.target.parentElement
          state.prevTarget.classList.add('drop-target')
        },
        // 鼠标松开
        onDrop: event => {
          // 兼容IE
          let ev = event || window.event
          // 阻止冒泡
          ev.stopPropagation()
          state.prevTarget.classList.remove('drop-target')
          state.targetObj = record
          exchangeTable()
        }
      }
    }
    const exchangeTable = () => {
      const { sourceObj, targetObj } = state
      emit('dragChange', {
        source: sourceObj,
        target: targetObj
      })
    }
    return {
      customRow,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="scss">
.drop-target {
  background: rgba(0, 0, 0, 0.15);
}
</style>
